import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import styled from 'styled-components';
import bridge from '@/config/JSbridge';
import bwmodel from "@/config/bwmodel";
import ModalView from '@/components/modal-view'
import { popNativePage } from "@/utils";

const isStorm = bwmodel.app === "storm";

const Home = ({ data, activeData, onNext, isLogin }, ref) => {
  const [showExit, setShowExit] = useState(false);
  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleClick = () => {
    if (!isStorm) {
      window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
      return;
    }

    if (!data.activeDays) {
      setShowExit(true)
      return;
    }

    if (isLogin) {
      onNext()
    } else {
      bridge.callHandler(
        'nativeEvent',
        {
          event: 'login',
          params: {
            refreshOnBack: true
          }
        },
        () => {}
      );
    }
  }

  const getName = () => {
    if (activeData.user) {
      return activeData.user.nickname;
    }
    if (data.myself.nickname) {
      return data.myself.nickname;
    }
    return '风云友友'
  }

  const handleExit = () => {
    popNativePage();
  }

  return (
    <Container className="page home-page" ref={containerRef}>
      <div className="home-title">
        <span>你好，</span>
        <span className="home-title-light">{getName()}</span>
      </div>
      <div className="logo-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/logo@2x.png" alt=""/>
      </div>
      <div className="home-bg">
        <img className="bg-img" src="https://file.wogoo.com/image/activity/active_205/home-bg@2x.png" alt=""/>
      </div>
      <div className="bottom-bg-wrap">
        <img className="bg-img" src="https://file.wogoo.com/image/activity/active_205/home-bottom-bg@2x.png" alt=""/>
      </div>
      <div className="start-bar" onClick={handleClick}>
        <div className="start-wrap">
          <img className="bg-img start-bar-img" src="https://file.wogoo.com/image/activity/active_205/start-bar@2x.png" alt=""/>
        </div>
      </div>
      <div className="home-claim">
        <div className="claim-year">
          <img className="year-text" src="https://file.wogoo.com/image/activity/active_205/year-text@2x.png" alt=""/>
        </div>
        <div>数据统计周期:2025.1.1-2025.12.30</div>
        <div>说明:选择“解锁"即确认授权相关数据</div>
      </div>
      <ModalView
        visible={showExit}
        onClose={() => setShowExit(false)}
        onOverlayClick={() => setShowExit(false)}
        content={
          <ModalContainer>
            <img className="exit-bg" src="https://file.wogoo.com/image/activity/active_205/exit-bg@2x.png" alt=""/>
            <div className="exit-content">
              <div className="exit-title">尊敬的用户，你好：</div>
              <div className="exit-text">你在我们本次活动的2025年数据统计周期内，暂无相关数据，因此无法进行相关总结和展示。谢谢！</div>
              <div className="exit-btn-wrap">
                <img onClick={handleExit} className="exit-btn" src="https://file.wogoo.com/image/activity/active_205/exit-btn@2x.png" alt=""/>
              </div>
            </div>
          </ModalContainer>
        }
      />
    </Container>
  )
}

const ModalContainer = styled.div`
  position: relative;
  .exit-bg {
    width: 310px;
  }
  .exit-content {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    left: 0;
    top: 0;
    padding: 220px 26px 0;
    color: #FFFFFF;
    .exit-title {
      font-size: 19px;
      line-height: 27px;
      font-weight: bold;
    }
    .exit-text {
      font-size: 15px;
      line-height: 27px;
      font-weight: normal;
    }
  }
  .exit-btn-wrap {
    display: flex;
    justify-content: center;
    margin-top: 28px;
    .exit-btn {
      width: 139px;
    }
  }
`;

const Container = styled.div`
  padding-top: 72px;
  .active-row {
    display: flex;
    .active-btn {
      font-weight: 600;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 30px;
      margin-right: 7px;
      text-align: center;
      height: 30px;
      background: linear-gradient( 173deg, #D52417 1%, #EF1C1C 71%);
      border-radius: 15px;
      flex: 1;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .active-row {
    padding: 0 20px;
  }
  .active-row1 {
   
  }
  .active-row2 {
    margin-top: 128px;
  }

  .home-bg {
    font-size: 0;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    left: 0;
    top: 87px;
  }
  .bottom-bg-wrap {
    font-size: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .start-bar {
    position: absolute;
    left: 0px;
    bottom: 100px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 47px 0 47px;
    .start-wrap {
      width: 100%;
      position: relative;
    }
    .start-finger-img {
      width: 67px;
      height: 67px;
      position: absolute;
      right: 0;
      bottom: -46px;
      right: -33px;
    }
  }
  .home-claim {
    position: absolute;
    bottom: 65px;
    left: 0;
    width: 100%;
    text-align: center;

    font-size: 11px;
    color: #1F1D1D;
    line-height: 17px;
  }
  .claim-year {
    .year-text {
      width: 84px;
    }
  }
  .home-title {
    font-weight: 600;
    font-size: 15px;
    color: #1F1D1D;
    line-height: 21px;
    letter-spacing: 2px;
    text-align: center;
    .home-title-light {
      color: #FF0000;
    }
  }
`;

export default React.memo(forwardRef(Home));


// WEBPACK FOOTER //
// ./src/views/activity_205/home.js